import './App.css';
import React, {Component} from 'react';

import ReactTooltip from 'react-tooltip';

const PricesAkpass = {
  'senior': {
    0: 0,
    1: 250,
    2: 335,
    3: 410,
    4: 465,
    5: 600,
    6: 905,
    7: 1805,
    8: 2270,
    9: 2995,
    10: 6215,
    11: 6655,
  },
  'youth': {
    0: 0,
    1: 220,
    2: 290,
    3: 355,
    4: 400,
    5: 520,
    6: 780,
    7: 1565,
    8: 1965,
    9: 2595,
    10: 5420,
    11: 5765,
  },
}

const TextAkpass = {
  0: 'Inget',
  1: '1 timme',
  2: '2 timmar',
  3: '3 timmar',
  4: '4 timmar',
  5: 'Heldag',
  6: '2-heldagar',
  7: 'Vecka',
  8: 'Klippkort 10 x 1 timme**',
  9: 'Klippkort 10 x 2 timmar',
  10: 'Säsongskort, försäsongspris***',
  11: 'Säsongskort, fullpris***',
};

class App extends Component {
  state = {
    people: [],
    ungdom: false,
    total: 0,
    akpassVal: 0,
    uthyrning: [],
    pre: 0,
    textAkpass: 'Inget',
  }

  calcFullPrice() {
    let tot = 0;
    const {ungdom} = this.state;
    const isUngdom = ungdom ? 'youth' : 'senior';
    this.state.uthyrning.forEach(uthyrd => {
      const {type} = uthyrd;
      const time = parseInt(uthyrd.time, 10);
      const price = Prices[type][isUngdom][time];
      console.log('price', price);
      tot = tot + price;
    });
    tot = tot + PricesAkpass[isUngdom][parseInt(this.state.akpassVal,10)];
    return tot;
  }
  calcTotPrice() {
    let tot = 0;
    this.state.people.forEach((pers) => {
      tot = tot + pers.price;
    });
    return tot;
  }
  render() {
    const u = this.state.ungdom;
    const pre = this.state.pre;
    let Akpass = (<div>
          <label htmlFor='vuxen'>Senior:</label>
          <input checked={!u} onChange={(e) => this.setState({ungdom: false})} type='radio' name='vuxen'
                 id='vuxen'>
          </input>
          <label htmlFor='ungdom'>Ungdom:</label>
          <input checked={u} onChange={(e) => this.setState({ungdom: true})} type='radio' name='ungdom' id='ungdom'>
          </input>
          <br /><br />
        <label for='akpass-vuxen'>Åkpass: </label>
        <select id='akpass' name="akpass" onChange={(e) => {
          let pre = 0;
          const v = e.target.value;
          if (v < 3) {
            pre = 0;
          } else if (v < 5) {
            pre = 1;
          } else {
            pre = 2;
          }
          this.setState({akpassVal: v, pre: pre, textAkpass: `${TextAkpass[v]}`});

        }} value={this.state.akpassVal}>
          <option value={0}>Inget</option>
          <option value={1}>1 timme ({!u ? PricesAkpass.senior[1] : PricesAkpass.youth[1]} kr)</option>
          <option value={2}>2 timmar ({!u ? PricesAkpass.senior[2] : PricesAkpass.youth[2]} kr)</option>
          <option value={3}>3 timmar ({!u ? PricesAkpass.senior[3] : PricesAkpass.youth[3]} kr)</option>
          <option value={4}>4 timmar ({!u ? PricesAkpass.senior[4] : PricesAkpass.youth[4]} kr)</option>
          <option value={5}>Heldag ({!u ? PricesAkpass.senior[5] : PricesAkpass.youth[5]} kr)</option>
          <option value={6}>2-heldagar ({!u ? PricesAkpass.senior[6] : PricesAkpass.youth[6]} kr)</option>
          <option value={7}>Vecka ({!u ? PricesAkpass.senior[7] : PricesAkpass.youth[7]} kr)</option>
          <option value={8}>Klippkort 10 x 1 timme** ({!u ? PricesAkpass.senior[8] : PricesAkpass.youth[8]} kr)</option>
          <option value={9}>Klippkort 10 x 2 timmar** ({!u ? PricesAkpass.senior[9] : PricesAkpass.youth[9]} kr)</option>
          <option value={10}>Säsongskort, försäsongspris*** ({!u ? PricesAkpass.senior[10] : PricesAkpass.youth[10]} kr)</option>
          <option value={11}>Säsongskort, fullpris*** ({!u ? PricesAkpass.senior[11] : PricesAkpass.youth[11]} kr)</option>
        </select>


      </div>
      );
    const {ungdom} = this.state;
    const isUngdom = ungdom ? 'youth' : 'senior';
    return (
        <div className="App">
          <div className='outer'>
            <div className='inner-right'>
              <div className='fifty'>
                {Akpass}
              </div>
              <div className='fifty'>
                <br />
                <form>
                  <label htmlFor='uthyrning'>Lägg till uthyrning: </label>
                  <select id='uthyrning' name='uthyrning'>
                    <option value='wakeboard-standard'>Wakeboard standard</option>
                    <option value='wakeboard-avancerad'>Wakeboard avancerad</option>
                    <option value='wakeskate'>Wakeskate</option>
                    <option value='comboskidor-standard'>Comboskidor standard</option>
                    <option value='kneeboard'>Kneeboard</option>
                    <option value='wakeskiis'>Wakeskiis</option>
                    <option value='kort-vatdrakt'>Kort våtdräkt</option>
                    <option value='lang-vatdrakt'>Lång våtdräkt (semi dry)</option>
                  </select>
                  <select id='uthyrning-tid' onChange={(e) => this.setState({pre:e.target.value})}>
                    <option selected={pre === 0} value={0}>1-2 h</option>
                    <option selected={pre === 1} value={1}>3-4 h</option>
                    <option selected={pre === 2} value={2}>Heldag</option>
                  </select>
                  <button onClick={(e) => {
                    e.preventDefault();
                    const type = document.getElementById('uthyrning');
                    const time = document.getElementById('uthyrning-tid');
                    this.setState({
                      uthyrning: [...this.state.uthyrning, {type: type.value, time: time.value}],
                    });
                  }}>+</button>
                </form>
              </div><br />
              Valt:
              <div className={'fifty'} style={{height:'130px', backgroundColor: '#ffffff', overflow: 'auto'}}>
                {this.state.textAkpass !== 'Inget' && (
                    <div className={'items'} id={'akpassValet'}>
                      Åkpass: {this.state.textAkpass} | {PricesAkpass[isUngdom][parseInt(this.state.akpassVal,10)]} kr
                    </div>
                )}
                {this.state.uthyrning.map((uthyrd, indx) => {
                  const {type} = uthyrd;
                  const time = parseInt(uthyrd.time, 10);
                  const price = Prices[type][isUngdom][time];
                  const name = Prices[type]['name'];
                  let howLong = '1-2 h';
                  if (time === 1) {
                    howLong = '3-4 h';
                  }
                  if (time === 2) {
                    howLong = 'Heldag';
                  }
                  return (
                      <div className={'items'} id={indx}>
                        • {name} | {howLong} | {price} kr  <button onClick={(e) => {
                          e.preventDefault();
                          const uthyrdaAtm = [...this.state.uthyrning];
                          uthyrdaAtm.splice(indx, 1);
                          this.setState({uthyrning: uthyrdaAtm});

                      }}>-</button>
                      </div>
                  )
                })}
              </div>
              <div>
                <br />
                Total: {this.calcFullPrice()} kr
              </div>
            </div>
            <div className='inner'>
              <div style={{flex:0.1}}>
                <div style={{justifySelf: 'flex-end'}}>
                  <button style={{width: '100%', height: 30}} onClick={(e) => {
                    e.preventDefault();
                    const name = u ? 'Ungdom' : 'Senior';
                    if (this.calcFullPrice() === 0) {
                      alert('Du har inte lagt till några produkter')
                    }else {
                      const person = {
                        name: name,
                        price: this.calcFullPrice(),
                        uthyrning: [...this.state.uthyrning],
                        textAkpass: this.state.textAkpass,
                      }
                      this.setState({
                        people: [...this.state.people, person],
                        ungdom: false,
                        total: 0,
                        akpassVal: 0,
                        uthyrning: [],
                        textAkpass: 'Inget',
                      });
                    }
                  }}>Lägg till åkare</button>
                </div>
              </div>
              <div style={{flex:0.8}}>
                {this.state.people.map((pers, indx) =>
                    {
                      let uthyrning = '';
                      if (pers.uthyrning.length > 0) {
                        pers.uthyrning.forEach((uthyrd) => {
                          const {type} = uthyrd;
                          const time = parseInt(uthyrd.time, 10);
                          const price = Prices[type][isUngdom][time];
                          const name = Prices[type]['name'];
                          let howLong = '1-2 h';
                          if (time === 1) {
                            howLong = '3-4 h';
                          }
                          if (time === 2) {
                            howLong = 'Heldag';
                          }
                          uthyrning += name + ' (' + howLong +')<br>';
                        });
                      }
                      const tooltip = 'Åkpass: ' + pers.textAkpass +'<br>' + uthyrning;
                      return (
                        <div className='person' data-tip={tooltip}>
                      {pers.name} | {pers.price} kr <button onClick={(e) => {
                        e.preventDefault();
                        const peopleAtm = [...this.state.people];
                        peopleAtm.splice(indx, 1);
                        this.setState({people: peopleAtm});
                      }}>-</button>
                        <ReactTooltip multiline />
                        </div>
                      )
                    }
                )}
              </div>
              <div className='total-cost' style={{flex:0.1, backgroundColor: '#f0f0f0', alignItems:'center'}}>
                Totalt: {this.calcTotPrice()} kr
              </div>

            </div>
          </div>
        </div>
    );
  }
}

const Prices = {
  'ingen': {
    'name': 'ingen',
    'senior': {
      0: 0,
      1: 0,
      2: 0,
    },
    'youth': {
      0: 0,
      1: 0,
      2: 0,
    }
  },
  'wakeboard-standard': {
    'name': 'Wakeboard standard',
    'senior': {
      0: 210,
      1: 250,
      2: 350,
    },
    'youth': {
      0: 160,
      1: 190,
      2: 265,
    }
  },
  'wakeboard-avancerad': {
    'name': 'Wakeboard avancerad',
    'senior': {
      0: 280,
      1: 335,
      2: 470,
    },
    'youth': {
      0: 215,
      1: 255,
      2: 360,
    }
  },
  'wakeskate': {
    'name': 'Wakeskate',
    'senior': {
      0: 145,
      1: 175,
      2: 245,
    },
    'youth': {
      0: 110,
      1: 135,
      2: 190,
    }
  },
  'comboskidor-standard': {
    'name': 'Comboskidor standard',
    'senior': {
      0: 210,
      1: 250,
      2: 350,
    },
    'youth': {
      0: 160,
      1: 190,
      2: 265,
    }
  },
  'kneeboard': {
    'name': 'Kneeboard',
    'senior': {
      0: 210,
      1: 250,
      2: 350,
    },
    'youth': {
      0: 90,
      1: 110,
      2: 150,
    }
  },
  'wakeskiis': {
    'name': 'Wakeskiis',
    'senior': {
      0: 280,
      1: 335,
      2: 470,
    },
    'youth': {
      0: 280,
      1: 335,
      2: 470,
    }
  },
  'kort-vatdrakt': {
    'name': 'Kort våtdräkt',
    'senior': {
      0: 95,
      1: 115,
      2: 160,
    },
    'youth': {
      0: 65,
      1: 80,
      2: 115,
    }
  },
  'lang-vatdrakt': {
    'name': 'Lång våtdräkt',
    'senior': {
      0: 125,
      1: 150,
      2: 210,
    },
    'youth': {
      0: 85,
      1: 100,
      2: 140,
    }
  },
}

export default App;
